import InteractiveCatalogPageItem from '../InteractiveCatalogPageItem';

export default class AnimatedImageItem extends InteractiveCatalogPageItem {

    constructor() {
        super();
        this.paths = [];
        this.step = 0.0;
        this.loop = false;

        this._images = [];
        this._currentIndex = -1;
        this._interval = undefined;
    }

    clear() {
        if (this._interval != undefined)
            clearInterval(this._interval);

        this._images = [];
        this._currentIndex = -1;
        this._interval = undefined;
    }

    start() {
        for (let img of this._images) {
            img.hide();
        }

        this._currentIndex = 0;
        this._images[this._currentIndex].show();
        this._interval = setInterval(this.onNext.bind(this), this.step*1000 / this._images.length);
    }

    onNext() {
        let nextIndex = this._currentIndex + 1;

        if (nextIndex == this._images.length) {
            if (!this.loop) {
                clearInterval(this._interval);
                return;
            }
            nextIndex = 0;
        }

        this._images[this._currentIndex].hide();
        this._currentIndex = nextIndex;
        this._images[this._currentIndex].show();
    }

}
